import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { createColumnHelper } from "@tanstack/react-table"
import { ApiEndpoints, reqGetNew } from "../../../../config/apiClient"
import DataTable from "../../../../components/dataTable/DataTable"

function NfServicosPage() {
    const [servicos, setServicos] = useState<iNfServicoDto[]>([])

    useEffect(() => {
        document.title = "NFSe Serviços | OB PORTUS"

        listarDados()
    }, [])

    async function listarDados() {
        const api = await reqGetNew(ApiEndpoints.nfseServicosConsultar)

        if (api.status === 200) {
            const clientesAux:iNfServicoDto[] = api.data
            setServicos(clientesAux)
        }
    }

    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = servicos[idx]
        const link = `/nfse/servico?cod_serv=${reg.servico_cod}`

        if (event.button === 1) {
            window.open(link)
        }
    }

    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = servicos[idx]
        const link = `/nfse/servico?cod_serv=${reg.servico_cod}`

        if (event.button === 0) {
            window.location.assign(link)
        }
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <h1 id="titleMain">NF Serviços</h1>
                <div className="div-row">
                    <Button onClick={() => {
                        window.location.assign(`/nfse/servico`)
                    }}>Cadastrar</Button>
                </div>
            </div>
            <br></br>
            {<DataTable dados={servicos} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />}
        </div>
    )
}

export default NfServicosPage

export interface iNfServicoDto {
    id:number | null
    servico_cod:string
    servico_descricao:string
    servico_item:number
    servico_subitem:number
    servico_descobro_nacional:number
    tributos_situacao:number
}

const columnHelper = createColumnHelper<iNfServicoDto>()

const defaultColumns = [
    columnHelper.accessor('servico_cod', {
        header: 'Cod. Serviço',
        size: 10,
    }),
    columnHelper.accessor('servico_descricao', {
        header: 'Razão Social',
        size: 300,
    }),
    columnHelper.accessor(row => `${row.tributos_situacao === 1 ? `Retido` : `Tributado`}`, {
        header: 'ISS',
        size: 30,
    }),
]

const defaultOrder:any = []